/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.sailboat\":\"Kaksi lintua taivaalla ja purjevene vedessä\"}");